import firebase from "firebase";

// Initialize Firebase
const config = {
  apiKey: "AIzaSyA95Zpx2itpBg6BpWY4rICDrbKc2_99FWo",
  authDomain: "cursohipertension-grehta.firebaseapp.com",
  databaseURL: "https://cursohipertension-grehta.firebaseio.com",
  projectId: "cursohipertension-grehta",
  storageBucket: "cursohipertension-grehta.appspot.com",
  messagingSenderId: "1033993350482",
  appId: "1:1033993350482:web:3c5767160484d5afb15e8b",
  measurementId: "G-3RPZZWGJ4P"
};

firebase.initializeApp(config);
firebase.auth().languageCode = 'es'
const auth = firebase.auth();
const functions = firebase.functions();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

const database = firebase.firestore();

export {
  database,
  auth,
  functions,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider
};
